import { render, staticRenderFns } from "./PromoOdrPopin.vue?vue&type=template&id=6dcfe2ba&scoped=true"
import script from "./PromoOdrPopin.vue?vue&type=script&lang=js"
export * from "./PromoOdrPopin.vue?vue&type=script&lang=js"
import style0 from "./PromoOdrPopin.vue?vue&type=style&index=0&id=6dcfe2ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcfe2ba",
  null
  
)

export default component.exports